import Cursor from "../../components/common/cusor";
import LoadingScreen from "../../components/common/loader";
import Navbar from "../../components/common/Navbar";
import { Helmet } from "react-helmet";
import { useContext } from "react";
import appContext from "../../context/AppContext";
import Chatbot from "../../components/chatbot";
import "./index.css";
import ProgressScroll from "../../components/common/ProgressScroll";

export default function ChatbotPage() {
  const context = useContext(appContext);
  const setIndex = context.setIndex;
  return (
    <>
      <Helmet>
        <title>Nithin Namani</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
      </Helmet>
      <div className="home-personal">
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Navbar handleSectionClick={setIndex} />
        <Chatbot />
      </div>
    </>
  );
}

// export default ChatbotPage
